// extracted by mini-css-extract-plugin
module.exports = {"CaseBox":"Accordion_CaseBox__3uplR","Active":"Accordion_Active__xpywG","CaseContent":"Accordion_CaseContent__1r_BM"};